import { useState } from 'react';
import { confirmDialog } from 'primereact/confirmdialog';
import AdjuntoService from '../service/AdjuntoService';
import { useToken } from '../components/useToken';
import * as generic from '../components/Generico';
export const useSubmitForm = ({ toast, onSuccess, setError }) => {
    const [dialogAnexo, setDialogAnexo] = useState(false);
    const [anexoPendientes, setAnexoPendientes] = useState(null);
    // Servicios y utilidades
    const adjuntoService = new AdjuntoService();
    const { closeSession } = useToken();

    const enviarFormulario = (id, urle, tipo, opcion = null) => {
        confirmDialog({
            message: '¿Está seguro? Si envía no podrá modificar la información',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => ejecutarEnvio(id, urle, tipo, opcion)
        });
    };

    const ejecutarEnvio = (id, urle, tipo, opcion) => {
        const data = { id: id, tipo: tipo };
        if (opcion) {
            data.opcion = opcion;
        }
        adjuntoService.enviar(data, urle).then(res => {
            // Soporta respuestas antiguas que solo envian success o success1 y las que lo envían dentro de status
            const isSuccess = (typeof res.data === 'string' && res.data.includes('success')) || (res.data && typeof res.data === 'object' && res.data.status && res.data.status.includes('success'));

            if (isSuccess) {
                toast.current?.show({ severity: "success", summary: "Cambio correcto", detail: res.message, life: 3000 });
                if (onSuccess) onSuccess(res);
                // Verificamos el string success1 ya sea directo o dentro de res.data.status
                if (res.data === 'success1' || (res.data && res.data.status === 'success1')) {
                    closeSession();
                    window.location.href = `${process.env.REACT_APP_WEBROOT}/`;
                }
            } else if (res.data === 'declarante' || res.data === 'sin') {
                toast.current?.show({ severity: "error", summary: "Error al enviar formulario", detail: res.message, life: 3000 });
            } else if (res.data === 'hijos_pendientes') { // En caso de que falten hijos por completar
                toast.current?.show({ severity: "warn", summary: "Acción requerida", detail: res.message, life: 5000 });
            }
            // Manejo de Anexos pendientes (El backend devuelve un array cuando hay pendientes)
            else if (Array.isArray(res.data) && res.data.length > 0) {
                setAnexoPendientes(res.data);
                // Mostrar el mensaje que viene del backend en lugar del fijo
                toast.current?.show({ severity: "error", summary: "Anexos pendientes", detail: res.message || "Debe subir los anexos pendientes", life: 3000 });
                setDialogAnexo(true); // Solo aquí se abre el dialog
            }
            // Fallback genérico por si el backend envía algo inesperado
            else {
                toast.current?.show({ severity: "error", summary: "Error", detail: res.message || "Ha ocurrido un error inesperado", life: 3000 });
            }
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    };

    return {
        enviarFormulario,
        dialogAnexo,
        setDialogAnexo,
        anexoPendientes
    };
};